import { APIContext } from "../../types";
import { makePath } from "../../../../api/url";
import * as APITypes from "../../../../api/cur8/generated-types/v1/Api";
import { getJSON } from "../../request";
import { applyParams } from "../../../params";

export function createUserAPI({ buildURL, fetchJSON, fetchRaw }: APIContext) {
  function getUser(userUri: string) {
    const path = makePath(["api", "v1", "user", userUri]);
    const url = buildURL(path);

    const request = getJSON(url);

    return fetchJSON<APITypes.User>(request);
  }

  function getUserProfilePhoto(options: APITypes.UserGetProfilePhotoParams) {
    const path = makePath(["api", "v1", "user", options.userUri, "photo"]);
    const url = buildURL(path);

    applyParams(url.searchParams, {
      size: options.size,
    });

    const request = new Request(url.toString());
    return fetchRaw(request);
  }

  return {
    getUser,
    getUserProfilePhoto,
  };
}
